import React, { useState, useEffect } from "react";
import { jwtDecode } from 'jwt-decode';
import {
  FiBarChart,
  FiChevronDown,
  FiChevronsRight,
  FiDollarSign,
  FiHome,
  FiMonitor,
  FiShoppingCart,
  FiTag,
  FiUsers, FiLogOut
} from "react-icons/fi";
import { motion } from "framer-motion";
import RevealBento from "./RevealBento";
import RevealBentoAdmin from "./RevealBentoAdmin";
import { useNavigate } from "react-router-dom";
export default function PreRegistroLayout() {
  const [user, setUser] = useState(null);
  const [activeView, setActiveView] = useState(() => localStorage.getItem("activeView") || "home");

  useEffect(() => {
    localStorage.setItem("activeView", activeView);
  }, [activeView]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");

    if (!token) {
      setUser(null);
      return;
    }
    try {
      const decoded = jwtDecode(token);
      // Combinar datos del token y de localStorage para asegurar que username esté disponible
      setUser({ ...decoded, ...storedUser });
    } catch {
      setUser(null);
    }
  }, []);


  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-white">
      {/* Hide sidebar on mobile (hidden), show on tablets and up (md:flex) */}
      <div className="hidden md:flex h-screen sticky top-0">
        <Sidebar user={user} setActiveView={setActiveView} />
      </div>

      <main className="flex-1 min-w-0 overflow-x-hidden">
        {/*(user?.role === "admin" || user?.role === "validador")
          ? <RevealBentoAdmin user={user} />
          : <RevealBento user={user} />
        */<RevealBento user={user} activeView={activeView} setActiveView={setActiveView} />}
      </main>

    </div>
  );
}

const Sidebar = ({ user, setActiveView }) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("Inicio");

  return (
    <motion.nav
      layout
      className="sticky top-0 h-screen shrink-0 border-r border-slate-300 bg-white p-2 flex flex-col"
      style={{
        width: open ? "225px" : "fit-content",
      }}
    >
      <TitleSection open={open} />

      {/* Sección de Usuario */}
      {user && (
        <div className={`mb-4 px-2 py-3 bg-slate-50 rounded-lg border border-slate-200 overflow-hidden transition-all ${open ? "opacity-100" : "opacity-0 invisible h-0 p-0 mb-0"}`}>
          <div className="flex items-center gap-2">
            <div className="size-8 rounded-full bg-indigo-600 flex items-center justify-center text-white text-xs font-bold shrink-0">
              {user.sub ? user.sub.charAt(0).toUpperCase() : "U"}
            </div>
            {open && (
              <div className="flex flex-col min-w-0">
                <span className="text-[10px] font-bold text-slate-800 truncate">
                  {user.username || user.sub || "Usuario"}
                </span>
                <span className="text-[9px] text-gray-400 truncate">
                  {user.email || "Sin correo"}
                </span>
                <div className="flex items-center gap-1 mt-0.5">
                  <span className="text-[9px] text-slate-400 font-mono">
                    #{user.id_user}
                  </span>
                </div>

              </div>
            )}
          </div>
        </div>
      )}

      <div className="space-y-1 flex-1">
        <Option Icon={FiHome} title="Inicio" selected={selected} setSelected={setSelected} open={open} setActiveView={setActiveView} />
        <Option Icon={FiLogOut} title="Salir" selected={selected} setSelected={setSelected} open={open} />

      </div>
      <ToggleClose open={open} setOpen={setOpen} />
    </motion.nav>
  );
};

const Option = ({ Icon, title, selected, setSelected, open, notifs, setActiveView }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (title === "Salir") {
      // Limpiar absolutamente todo el localStorage
      localStorage.clear();
      // Redirigir al inicio (raíz) para disparar el flujo de Keycloak
      window.location.replace('/');
      return;
    }
    if (title === "Inicio" && setActiveView) {
      setActiveView("home");
    }
    // Cambiar opción seleccionada para las demás
    setSelected(title);
  };

  return (
    <motion.button
      layout
      onClick={handleClick}
      className={`relative flex h-10 w-full items-center rounded-md transition-colors ${selected === title
        ? "bg-indigo-100 text-indigo-800"
        : "text-slate-500 hover:bg-slate-100"
        }`}
    >
      <motion.div layout className="grid h-full w-10 place-content-center text-lg">
        <Icon />
      </motion.div>
      {open && (
        <motion.span
          layout
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.125 }}
          className="text-xs font-medium"
        >
          {title}
        </motion.span>
      )}
      {notifs && open && (
        <motion.span
          initial={{ scale: 0, opacity: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5 }}
          className="absolute right-2 top-1/2 size-4 rounded bg-indigo-500 text-xs text-white flex items-center justify-center"
        >
          {notifs}
        </motion.span>
      )}
    </motion.button>
  );
};


const TitleSection = ({ open }) => {
  return (
    <div className="mb-3 border-b border-slate-300 pb-3">
      <div className="flex cursor-pointer items-center justify-between rounded-md transition-colors hover:bg-slate-100">
        <div className="flex items-center gap-2">
          <Logo />
          {open && (
            <motion.div
              layout
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.125 }}
            >
              <span className="block text-xs font-semibold">IPEJAL</span>
              <span className="block text-xs text-slate-500">Pre-registro</span>
            </motion.div>
          )}
        </div>
        {open && <FiChevronDown className="mr-2" />}
      </div>
    </div>
  );
};

const Logo = () => {
  return (
    <motion.div
      layout
      className="grid size-10 shrink-0 place-content-center rounded-md "
    >
      <img
        src="/images/index/ico.png"
        alt="Logo"
        className="    rounded-xl shadow-md border  bg-white p-1"
      />
    </motion.div>
  );
};

const ToggleClose = ({ open, setOpen }) => {
  return (
    <motion.button
      layout
      onClick={() => setOpen((pv) => !pv)}
      className="absolute bottom-0 left-0 right-0 border-t border-slate-300 transition-colors hover:bg-slate-100"
    >
      <div className="flex items-center p-2">
        <motion.div layout className="grid size-10 place-content-center text-lg">
          <FiChevronsRight className={`transition-transform ${open && "rotate-180"}`} />
        </motion.div>
        {open && (
          <motion.span
            layout
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.125 }}
            className="text-xs font-medium"
          >
            Ocultar
          </motion.span>
        )}
      </div>
    </motion.button>
  );
};
